const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const resetLocationImages = (locationID) => {
	document.querySelectorAll(`${locationID} .location-item-image`).forEach( el => {
		el.classList.add('d-none');
	} )
}

const observerCallback = (entries, observer) => {

	entries.forEach((entry) => {
		if(entry && entry.isIntersecting) {
			const query = entry.target.dataset.sliderImageQuery;
			const locationSlider = entry.target.dataset.sliderId;

			// //prepare the next lazy loaded image (it does not work)
			// const nextIMG = document.querySelector(`${locationSlider} .location-item-image[data-location-image="${parseInt(entry.target.dataset.locationItem) + 1}"]`);
			// if (nextIMG)
			// 	nextIMG.setAttribute("loading", 'eager');

			resetLocationImages(locationSlider);
			document.querySelector(query).classList.remove('d-none');
		}
	});
}

const InitLocationSliders = () => {

	const locationSliders = document.querySelectorAll('.locations-slider');

	if (!locationSliders || locationSliders.length === 0)
		return;

	locationSliders.forEach( (slider,index) => {

		/* Dynamically generate and assign an id for each slider for the observers to work. */
		const sliderID = `location-slider-${index}`;
		slider.setAttribute('id', sliderID);

		/* Observer options, root must be null for the observer to work relative to view port. */
		const observerOptions = {
			root: null,
			rootMargin: "0px",
			threshold: 1,
		};

		const observer = new IntersectionObserver(observerCallback, observerOptions);

		let targets = document.querySelectorAll(`#${sliderID} .location-item-text`);

		if (!targets || targets.length === 0)
			return;

		targets.forEach( el => {

			/* Assign the image query for the current location slider for each item
			 * before we add them in our observer to make sure multiple sections of the same type will work together.
			 * */
			const targetID = el.dataset.locationItem;
			el.setAttribute('data-slider-id', `#${sliderID}`); /* Parent slider id */
			el.setAttribute('data-slider-image-query', `#${sliderID} .location-item-image[data-location-image="${targetID}"]`); /* Image query */
			observer.observe(el);
		});

	} )
}


const App = {
	init() {
		InitLocationSliders();
	}
};

domLoaded(() => {
	App.init();
});
